// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { AdminTemplate } from 'components/templates/AdminTemplate';
import { useHistory, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { Path } from 'routes';
import { CustomizeItemBreadcrumbs } from 'util/Types';
import { getOperatorParentBreadCrumb } from 'util/commons';
import EmissionSiteDetailManagement from 'components/organisms/EmissionSiteDetailManagement';
import { useQuery } from 'util/queryParams';
import { OperatorType } from 'util/Enums';
import ProducerSiteDetailManagement from 'components/organisms/ProducerSiteDetailManagement';

const AdminCustomizeItems = () => {
  const history = useHistory();
  const { operatorId } = useParams<{
    siteId: string;
    operatorId: string;
  }>();
  const [breadcrumb, setBreadcrumb] = useState<CustomizeItemBreadcrumbs>({
    operatorName: '-',
    siteName: '-',
  });
  const query = useQuery();
  const managementType =
    (query.get('type') as OperatorType) || OperatorType.Emissions;

  const managementScreenMap: {
    [key in OperatorType]?: {
      title: string;
      component: JSX.Element;
    };
  } = useMemo(
    () => ({
      [OperatorType.Emissions]: {
        title: 'アカウントマスタ編集',
        component: (
          <EmissionSiteDetailManagement
            onSetBreadcrumb={setBreadcrumb}
            showTemporaryStorage
          />
        ),
      },
      [OperatorType.Compressions]: {
        title: 'アカウントマスタ編集',
        component: (
          <EmissionSiteDetailManagement onSetBreadcrumb={setBreadcrumb} />
        ),
      },
      [OperatorType.Recycle]: {
        title: 'アカウントマスタ編集',
        component: (
          <EmissionSiteDetailManagement onSetBreadcrumb={setBreadcrumb} />
        ),
      },
      [OperatorType.Producer]: {
        title: '製品化マスタ設定',
        component: (
          <ProducerSiteDetailManagement onSetBreadcrumb={setBreadcrumb} />
        ),
      },
    }),
    [setBreadcrumb]
  );

  useEffect(() => {
    if (!managementScreenMap[managementType]) {
      history.replace(`${Path.adminOperatorListManagement}/${operatorId}`);
    }
  }, [managementType, managementScreenMap]);

  return (
    <AdminTemplate
      h1={managementScreenMap[managementType]?.title || ''}
      active={getOperatorParentBreadCrumb()}
      breadcrumb={[
        {
          label: getOperatorParentBreadCrumb(),
          href: `${Path.adminOperatorListManagement}${window.location.search}`,
        },
        {
          label: breadcrumb.operatorName || '-',
          href: `${Path.adminOperatorListManagement}/${operatorId}${window.location.search}`,
        },
        {
          label: breadcrumb.siteName || '-',
        },
      ]}
    >
      {managementScreenMap[managementType]?.component}
    </AdminTemplate>
  );
};

export default AdminCustomizeItems;
